//tslint:disable:export-name
import { Container } from 'hypo-container';
import { ConfigStore } from './ConfigStore';
import { SubscriptionsService } from './SubscriptionsService';
import { AutoReplenishmentViewController } from '../internal/controllers/AutoReplenishmentViewController';
import serviceNames from '~setup/SubscriptionsService';
import { IAppConfig } from '@estee/elc-universal-utils';

export const diContainer = new Container();

export const setConfig = (configJSON: IAppConfig) => {
    diContainer.config = configJSON;
};

diContainer
    .register(serviceNames.subscriptionsService, (c) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new SubscriptionsService(setConfig);
    })
    .register(serviceNames.configStore, (c) => new ConfigStore(c.config))
    .register(
        serviceNames.autoReplenishmentViewController,
        diContainer.factory((c) => new AutoReplenishmentViewController())
    );
